// extracted by mini-css-extract-plugin
module.exports = {"customTip":"TipsApplier_customTip__-W_6R"};